import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getEmployee } from './MngSlice'
import Pagination from '../Common/Pagination'
import { Container, Row, Table, Button, Form, Col } from 'react-bootstrap'
import { ToastContainer } from 'react-toastify'
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from 'react-router-dom'
import FilterEmpDetailsModel from '../HR/Model/FilterEmpDetailsModel'
import useGetEmployees from '../Common/ReuseApi/useGetEmployees'
import ViewEmployeeFilter from '../Common/Filter/ViewEmployeeFilter'

const MngManageEmp = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const loginUserData = useSelector((state) => state.loginData.userData)
    const manageEmp = useSelector(state => state?.mngData?.mngManageEmp)
    const role = loginUserData?.resourceType;

    const [empId, setEmpId] = useState(null)
    const [docsPerPage, setDocsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [show, setShow] = useState(false);
    const [showFilter, setShowFilter] = useState(false)

    // call custom hook
    const { employeeOptions } = useGetEmployees();

    useEffect(() => {
        getFilterData();
    }, [currentPage, docsPerPage])

    const getFilterData = (page = currentPage) => {
        const endPoint = "/emp/getParticularTlEmployee1"
        const payload = {
            empIdTL: loginUserData?.empId,
            empId: empId?.value || "",
            name: "",
            label: "",
            designation: "",
            workEmail: "",
            isApproved: "",
            resourceType: "",
            documentsPerPage: docsPerPage,
            page: page
        }
        dispatch(getEmployee({ endPoint, payload }))
    }

    const handlerCloseModel = () => setShow(false)
    const handlerCloseFilterModel = () => setShowFilter(false)

    // function for pagination
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);

    };
    const handleDocsPerPage = (docsPageProp) => {
        setCurrentPage(1);
        setDocsPerPage(docsPageProp);
    }

    const handleSearch = () => {
        setCurrentPage(1)
        getFilterData(1)
    }
    const handleClear = () => {
        setEmpId(null)
        setCurrentPage(1)
        dispatch(getEmployee({
            endPoint: "/emp/getParticularTlEmployee1",
            payload: {
                empIdTL: loginUserData?.empId,
                empId: "",
                name: "",
                label: "",
                designation: "",
                workEmail: "",
                isApproved: "",
                resourceType: "",
                documentsPerPage: docsPerPage,
                page: currentPage
            }
        }))
    }

    return (
        <div className="outletPadding mx-auto" data-aos="fade-up">
            <Container>
                <ToastContainer />
                <ViewEmployeeFilter
                    role={role}
                    employeeOptions={employeeOptions}
                    empId={empId}
                    setEmpId={setEmpId}
                    onSearch={handleSearch}
                    onClear={handleClear}
                />

                <div className='outer-wrapper mx-auto'>
                    <div className='table-wrapper'>
                        <table>
                            <thead>
                                <tr className='tbl-header'>
                                    <th>Sr. No.</th>
                                    <th className='assignwidth1'>Employee ID</th>
                                    <th className='assignwidth1'>Name</th>
                                    {
                                        loginUserData?.resourceType === "humanResource" &&
                                        <>
                                            <th className='assignwidth1'>Depatment</th>
                                            <th className='assignwidth1'>SubDepatment</th>
                                            <th className='assignwidth1'>Designation</th>
                                            <th className='assignwidth1'>Resource Type</th>
                                            <th>Contact No</th>
                                        </>
                                    }

                                    <th className='assignwidth1'>Email</th>
                                    <th>IDC</th>
                                    <th>QWD</th>
                                    <th>Slippage</th>
                                    <th>Efficiency</th>
                                    <th>Action</th>
                                </tr>

                            </thead>

                            <tbody>
                                {manageEmp?.data !== null &&
                                    manageEmp?.data !== undefined &&
                                    manageEmp?.data?.length > 0
                                    ? manageEmp?.data?.map((values, index) => {
                                        return (
                                            <>
                                                <tr>
                                                    {currentPage !== 1 ? (<td> {index + 1 + 10 * (currentPage - 1)}</td>) : <td>{index + 1}</td>}
                                                    <td>{values?.empId ? values?.empId : "-"}</td>
                                                    <td>{`${values?.firstName} ${values?.lastName}`}</td>
                                                    {
                                                        loginUserData?.resourceType === "humanResource" &&
                                                        <>
                                                            <td>{values?.department[0].label ? values?.department[0].label : "-"}</td>
                                                            <td>{values?.subDepartmentName[0] ? values?.subDepartmentName[0] : "-"}</td>
                                                            <td>{values?.designation}</td>

                                                            <td>{values?.resourceType ? values?.resourceType[0].toUpperCase() + values?.resourceType.slice(1).toLowerCase() : "-"}</td>
                                                            <td>{values?.contactNo}</td>
                                                        </>
                                                    }

                                                    <td>{values?.workEmail}</td>
                                                    <td>
                                                        {values?.idc ? values?.idc?.toFixed(2) : 0}
                                                    </td>
                                                    <td>
                                                        {values?.qwd ? values.qwd?.toFixed(2) : 0}
                                                    </td>

                                                    <td>
                                                        {values?.efficiency ? values?.efficiency?.toFixed(2) : 0}
                                                    </td>

                                                    <td>
                                                        {values?.slippage ? values?.slippage?.toFixed(2) : 0}
                                                    </td>

                                                    <td>
                                                        <span
                                                            data-toggle="tooltip"
                                                            title="view"
                                                            style={{
                                                                color: "#000000",
                                                                fontSize: "20px",
                                                            }}
                                                        >
                                                            <Icon.Eye
                                                                onClick={() =>
                                                                    navigate(
                                                                        "employee-details",
                                                                        {
                                                                            state: { data: values },
                                                                        }
                                                                    )
                                                                }
                                                            />
                                                        </span>

                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    })
                                    : <tr><td colSpan={8}>
                                        No Data available
                                    </td></tr>}
                            </tbody>

                        </table>
                    </div>
                </div>
                <div className="pagination-wrapper p-0">
                    <Pagination currentPage={currentPage} totalPages={manageEmp?.noOfPages}
                        onPageChange={handlePageChange} onDocsPerPage={handleDocsPerPage} />
                </div>
            </Container>
        </div>
    )
}

export default MngManageEmp